import { useCookies } from "react-cookie";
import useStore from "../lib/store";
import { useEffect } from "react";

export default function usePortCookies() {
    const [cookies, , removeCookie] = useCookies(['displayCurrency', 'likedRentals']);
    const setLikedRentalIds = useStore((state) => state.setLikedRentalIds);
    const setDisplayCurrency = useStore((state) => state.setDisplayCurrency);

    useEffect(() => {
        if (cookies.displayCurrency) {
            setDisplayCurrency(cookies.displayCurrency);
            removeCookie('displayCurrency'); // Clear cookie after reading
        }
        if (cookies.likedRentals) {
            setLikedRentalIds(cookies.likedRentals);
            removeCookie('likedRentals'); // Clear cookie after reading
        }
    }, [
        cookies.displayCurrency,
        cookies.likedRentals,
        removeCookie,
        setDisplayCurrency,
        setLikedRentalIds,
    ]);
}
